import { Paper } from '@mui/material'
import { Dashboard } from '@mui/icons-material'
import { inject } from 'mobx-react'
import * as React from 'react'
import ResponsiveAppBar from '../common/ResponsiveAppBar'
import { IStores } from '../Stores'
import SurgicalPatientFlowModule from './modules/SurgicalPatientFlowModule'

interface IDashboardPageProps {
  setCanSwitchOrganizations?: (canSwitch: boolean) => void
}

class DashboardPage extends React.Component<IDashboardPageProps> {
  public componentDidMount() {
    this.props.setCanSwitchOrganizations!(true)
  }

  public componentWillUnmount() {
    this.props.setCanSwitchOrganizations!(false)
  }

  public render() {
    return (
      <>
        <ResponsiveAppBar title="Coordinator Dashboard" pageIcon={<Dashboard />} />
        <Paper style={{ margin: '20px', height: '100%', paddingBottom: '20px' }}>
          <SurgicalPatientFlowModule />
        </Paper>
      </>
    )
  }
}

const InjectedDashboardPage = inject<
  IStores,
  IDashboardPageProps,
  Partial<IDashboardPageProps>,
  any
>((stores: IStores) => ({
  setCanSwitchOrganizations: stores.global.setCanSwitchOrganizations,
}))(DashboardPage)

export default InjectedDashboardPage
